var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusIconFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus_icon",
    "data-name": "bus icon",
    transform: "translate(-426 -93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3876",
    "data-name": "Rectangle 3876",
    width: 28,
    height: 28,
    transform: "translate(426 93)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15839",
    "data-name": "Group 15839",
    transform: "translate(428.8 99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_716",
    "data-name": "Line 716",
    d: "M21.163.224H-.263A.487.487,0,0,1-.75-.263.487.487,0,0,1-.263-.75H21.163a.487.487,0,0,1,.487.487A.487.487,0,0,1,21.163.224Z",
    transform: "translate(0.95 16.495)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_881",
    "data-name": "Ellipse 881",
    cx: 0.649,
    cy: 0.649,
    r: 0.649,
    transform: "translate(9.901 11.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_882",
    "data-name": "Ellipse 882",
    cx: 0.649,
    cy: 0.649,
    r: 0.649,
    transform: "translate(17.043 11.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15925",
    "data-name": "Group 15925",
    transform: "translate(-2.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15923",
    "data-name": "Group 15923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_715",
    "data-name": "Line 715",
    d: "M.224,1.948H-.75V0H.224Z",
    transform: "translate(9.84 14.284)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_718",
    "data-name": "Line 718",
    d: "M.224,1.948H-.75V0H.224Z",
    transform: "translate(12.437 14.284)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15924",
    "data-name": "Group 15924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_720",
    "data-name": "Line 720",
    d: "M.224,1.948H-.75V0H.224Z",
    transform: "translate(16.333 14.284)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_721",
    "data-name": "Line 721",
    d: "M.224,1.948H-.75V0H.224Z",
    transform: "translate(18.93 14.284)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15922",
    "data-name": "Group 15922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3846",
    "data-name": "Rectangle 3846",
    d: "M1.948.974a.975.975,0,0,0-.974.974V12.986a.975.975,0,0,0,.974.974h9.09a.975.975,0,0,0,.974-.974V1.948a.975.975,0,0,0-.974-.974H1.948m0-.974h9.09a1.948,1.948,0,0,1,1.948,1.948V12.986a1.948,1.948,0,0,1-1.948,1.948H1.948A1.948,1.948,0,0,1,0,12.986V1.948A1.948,1.948,0,0,1,1.948,0Z",
    transform: "translate(7.629)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15921",
    "data-name": "Group 15921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15920",
    "data-name": "Group 15920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3847",
    "data-name": "Rectangle 3847",
    d: "M.974.974V7.467H12.012V.974H.974M0,0H12.986V8.441H0Z",
    transform: "translate(7.629 2.597)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_719",
    "data-name": "Line 719",
    d: "M.224,7.142H-.75V0H.224Z",
    transform: "translate(14.709 2.922)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15919",
    "data-name": "Group 15919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_717",
    "data-name": "Line 717",
    d: "M3.633.224h-3.9A.487.487,0,0,1-.75-.263.487.487,0,0,1-.263-.75h3.9a.487.487,0,0,1,.487.487A.487.487,0,0,1,3.633.224Z",
    transform: "translate(12.437 12.599)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_853_-_Outline",
    "data-name": "Ellipse 853 - Outline",
    d: "M.649,0A.649.649,0,1,1,0,.649.649.649,0,0,1,.649,0Z",
    transform: "translate(9.901 11.687)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_854_-_Outline",
    "data-name": "Ellipse 854 - Outline",
    d: "M.649,0A.649.649,0,1,1,0,.649.649.649,0,0,1,.649,0Z",
    transform: "translate(17.044 11.687)",
    fill: "#19bc9c"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusIconFront);
export default __webpack_public_path__ + "static/media/busIconFront.d38503ccb9f8205404e4bc944228d179.svg";
export { ForwardRef as ReactComponent };